import api from '../http/api'
import store from "../store/index";
import {getLocalAvatarByUserInfo, dataURLtoBlob } from '@/utils/utils.js'
import {avatarName} from '@/utils'
import loginSDK from '@/utils/base.js'

async function initCardUserInfo () {
  await getCardUserInfo()
  await initUserAvatar()
}

// 获取卡片用户信息
async function getCardUserInfo () {
  if (loginSDK.getCurrentToken()) { 
    const res = await api.user.getCardUser()
    store.commit("setCardUser", res.data);
  }
  return store.state.cardUser;
}

// 初始化用户头像
async function initUserAvatar () {
  const { cardUser } = store.getters
  if (!cardUser || cardUser && !cardUser.properties) return
  const hasAvatarObj =  await getUserAvatarInfo(cardUser)
  if (hasAvatarObj) {
    await syncAvatar(hasAvatarObj)
  }
}

// 获取未上传到oss的头像，如没有头像，则生成头像（base64）
function getUserAvatarInfo (user) {
  const { avatar } = user.properties
  // 处理存储的base64头像
  const avatarIsBase64 = avatar.search('data:image/png;base64,') !== -1
  // 处理旧的固定头像
  const avatarIsOld = ['0', '1', '2', '3'].indexOf(avatar) !== -1
  const avatarInOss = avatar && !avatarIsBase64 && !avatarIsOld
  if (!avatarInOss) {
    return avatarIsBase64 ? avatar : getLocalAvatarByUserInfo(user.properties)
  }
}

/**
 * 用于上传生成的base64的头像
 * @param params
 * @returns {Promise<void>}
 */
async function syncAvatar (params) {
  // const { userId } = store.getters.cardUser
  const fileName = avatarName()
  // oss上传需要blob转file
  const finaAvatar = new File([dataURLtoBlob(params)],`${fileName}.png`,{type:'image/png'})
  try {
    const {name, url} = await loginSDK.uploadFilesRequest({uploadfile: finaAvatar})
    const avatarObj = {
      avatar: url
    }
    await api.user.uploadUserAvatar(avatarObj)
  } catch (error) {
    console.log(error,"finaerror")
  }
}

export {
  initCardUserInfo
}